import { FilterOptions } from "@/stores/useFilterStore.ts";

export const getFiltersByIds = (companyIds: string[], optionsList: FilterOptions[], isFilterCompany: boolean): FilterOptions[] => {
  const companyIdSet = new Set(companyIds);
  if (isFilterCompany) {
    return optionsList.filter(option => {
      return option.companyIds?.some(id => companyIdSet.has(id));
    });
  } else {
    return optionsList.filter(option => {
      return companyIdSet.has(option.id);
    });
  }
};
